import { useCallback, useEffect, useState } from "react";

import {
  fetchAviationTaxonomy,
  type AviationTaxonomyResponse,
} from "@services/aviationTaxonomy";

export interface UseAviationWizardTaxonomyResult {
  taxonomy: AviationTaxonomyResponse | null;
  loading: boolean;
  error: string | null;
  reload: () => void;
}

export function useAviationWizardTaxonomy(
  enabled: boolean,
  countryCode = "USA",
): UseAviationWizardTaxonomyResult {
  const [taxonomy, setTaxonomy] = useState<AviationTaxonomyResponse | null>(null);
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState<string | null>(null);
  const [reloadToken, setReloadToken] = useState(0);

  const reload = useCallback(() => {
    setReloadToken((value) => value + 1);
  }, []);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      setError(null);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    fetchAviationTaxonomy(countryCode)
      .then((data) => {
        if (!cancelled) {
          setTaxonomy(data);
          setLoading(false);
        }
      })
      .catch((err: unknown) => {
        if (!cancelled) {
          setTaxonomy(null);
          setLoading(false);
          setError(err instanceof Error ? err.message : String(err));
        }
      });

    return () => {
      cancelled = true;
    };
  }, [enabled, countryCode, reloadToken]);

  return { taxonomy, loading, error, reload };
}
